import {
  GET_MASTERS_FAIL,
  GET_MASTERS_REQUEST,
  GET_MASTERS_SUCCESS,
  ADD_MASTER_FAIL,
  ADD_MASTER_REQUEST,
  ADD_MASTER_SUCCESS,
  EDIT_MASTER_FAIL,
  EDIT_MASTER_REQUEST,
  EDIT_MASTER_SUCCESS,
  DELETE_MASTER_FAIL,
  DELETE_MASTER_REQUEST,
  DELETE_MASTER_SUCCESS
} from "./actions";
import { IMaster } from "app/api/types";

interface IState {
  isLoading: boolean;
  masterList: IMaster[];
}
const initialState: IState = {
  masterList: [],
  isLoading: false
};

const mastersReducer = (
  state = initialState,
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case GET_MASTERS_REQUEST:
    case EDIT_MASTER_REQUEST:
    case ADD_MASTER_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case DELETE_MASTER_REQUEST:
      return {
        ...state
      };

    case ADD_MASTER_FAIL:
    case GET_MASTERS_FAIL:
    case EDIT_MASTER_FAIL:
      return {
        ...state,
        isLoading: false
      };

    case DELETE_MASTER_FAIL:
      return {
        ...state
      };

    case GET_MASTERS_SUCCESS:
      return {
        ...state,
        masterList: action.payload,
        isLoading: false
      };

    case ADD_MASTER_SUCCESS:
    case EDIT_MASTER_SUCCESS:
      return {
        ...state,
        isLoading: false
      };

    case DELETE_MASTER_SUCCESS:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
};

export default mastersReducer;
